var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"check-availability",attrs:{"data-e2e":"checkAvailabilitySection"}},[_c('p',{staticClass:"check-availability__title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('AlButton',{attrs:{"to":_vm.to}},[_vm._v("\n    "+_vm._s(_vm.btnText)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }